import { ReactNode, PropsWithChildren } from 'react';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { Link } from '@framework/router/Next/Link';
import { UrlObject } from 'url';

interface ILinkWithTooltipProps extends PropsWithChildren {
  url: string | UrlObject,
  tooltipContent: ReactNode,
  dataTest: string,
  linkClassName?: string,
  tooltipClassName?: string,
  stopPropagation?: boolean,
}

const LinkWithTooltip = ({
  url,
  tooltipContent,
  children,
  linkClassName,
  tooltipClassName,
  stopPropagation = true,
  ...rest
}: ILinkWithTooltipProps) => (
  <Tooltip content={ tooltipContent } wrpClassName={ tooltipClassName }>
    <Link
      to={ url }
      className={ linkClassName }
      stopPropagation={ stopPropagation }
      { ...rest }
    >
      { children }
    </Link>
  </Tooltip>
);

export default LinkWithTooltip;
